module.exports = __webpack_public_path__ + "static/media/microscope.07ba66e2.svg";